export interface SparkPoint {
  label: string;
  current: number;
  previous: number;
  currentFormattedValue?: string;
  previousFormattedValue?: string;
  /** Same bucket as `label` when API sends both (daily current-period date). */
  current_start_date?: string;
  /** Comparison-period date aligned to this bucket (daily previous-period date). */
  previous_start_date?: string;
}

export interface ShopifyMetric {
  key: "netRevenue" | "totalSales" | "orders" | "netQuantity" | "discount" | "returns" | "refunds";
  title: string;
  value: string;
  delta: number;
  deltaLabel: string;
  previousDate: string;
  currentDate: string;
  spark: SparkPoint[];
}

export interface CityRevenueItem {
  city: string;
  net_revenue: number;
  net_revenueFormattedValue?: string;
  customers?: number;
  customersFormattedValue?: string;
  customer_count?: number;
  orders?: number;
  ordersFormattedValue?: string;
  order_count?: number;
  return_value?: number;
  return_valueFormattedValue?: string;
  return_count?: number;
  return_countFormattedValue?: string;
  latitude?: number;
  longitude?: number;
}

export interface ShopifyRegion {
  id: string;
  title: string;
  cityMapTitle: string;
  heatmapTitle: string;
  donutTitle: string;
  metrics: ShopifyMetric[];
  cities: CityRevenueItem[];
  heatmap: number[][];
  heatmapRaw: number[][];
  products: Array<{ name: string; value: number; valueFormattedValue?: string; color: string }>;
}

export const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const HOUR_LABELS = [
  "12 AM",
  "1 AM",
  "2 AM",
  "3 AM",
  "4 AM",
  "5 AM",
  "6 AM",
  "7 AM",
  "8 AM",
  "9 AM",
  "10 AM",
  "11 AM",
  "12 PM",
  "1 PM",
  "2 PM",
  "3 PM",
  "4 PM",
  "5 PM",
  "6 PM",
  "7 PM",
  "8 PM",
  "9 PM",
  "10 PM",
  "11 PM",
];
